module.exports = __webpack_public_path__ + "static/media/loader.50fede9b.svg";